<script>
  import Config from './Config.svelte'
  import Gridify from './Gridify.svelte'
  import { onMount } from 'svelte'
  import { getData, getDatasets, getMetadata } from 'modules/oddata.js'
  import {
    apiUrl,
    attributes,
    data,
    dataset,
    datasets,
    init,
    layers,
    metadata,
    rowsLimit,
    view,
  } from 'modules/stores.js'
  import { preferences } from 'modules/preferences.js'

  const updateDatasets = url => {
    $datasets = { _status: 'pending' }
    getDatasets({ apiUrl: url }).then(ds => {
      $datasets = ds
      if ($view === 'gridify' && ds._status !== 'ok') {
        $view = 'config'
      }
    })
  }
  const updateDataset = ds => {
    if (ds._status !== 'ok') {
      return
    }
    if (ds.includes(preferences.dataset)) {
      $dataset = preferences.dataset
    } else {
      $dataset = ds[0]
    }
  }
  const updateMetadata = (d, url) => {
    if (d) {
      getMetadata(d, { apiUrl: url }).then(m => {
        $metadata = m
      })
    }
  }
  const updateAttributes = m => {
    if ('attributes' in m && Array.isArray(m.attributes)) {
      $attributes = m.attributes.map(a => a.name)
    }
  }
  const updateData = (m, limit, url) => {
    if ('attributes' in m && Array.isArray(m.attributes)) {
      getData(m, { rowsLimit: limit, apiUrl: url }).then(d => {
        $data = d
      })
    }
  }

  const setOneDefaultLayer = attributes => {
    const layer = { mode: preferences.mode }
    if (!attributes || attributes.length === 0) {
      return
    }
    if (as.includes(preferences.attribute)) {
      layer.attribute = preferences.attribute
    } else {
      layer.attribute = attributes[0]
    }
    $layers = [layer]
  }

  /* TODO: improve to keep the existing layers if possible */
  const updateLayers = attributes => {
    // setOneDefaultLayer(attributes)
  }

  $: updateDatasets($apiUrl)
  $: updateDataset($datasets)
  $: updateMetadata($dataset, $apiUrl)
  $: updateAttributes($metadata)
  $: updateData($metadata, $rowsLimit, $apiUrl)
  $: updateLayers($attributes)
  onMount(() => {
    updateDatasets($apiUrl)
  })
</script>

<style global type="text/scss">
  @import '../global.scss';
</style>

{#if $view === 'gridify' && $datasets._status === 'ok'}
  <Gridify />
{:else if $view === 'config'}
  <Config />
{/if}
